var ns;
ns.App.factory('InsideProcessService', function(
  HttpFactory, API_ENDPOINT
  ){
  return {
    checkInsideProcess: function (params) {
      var endpoint = API_ENDPOINT + '/inside_process_check';
      return HttpFactory.createPost(endpoint, params);
    },
    getSetting: function (params) {
      var endpoint = API_ENDPOINT + '/inside_process_setting';
      return HttpFactory.createPost(endpoint, params);
    }
  };
});